import * as React from 'react'
import * as box2d from 'box2d.ts'
import './styles.scss'

type Props = {
    zIndex: number
}

const scale = (num, in_min, in_max, out_min, out_max) => {
    return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

export default class MoneyCover extends React.Component<Props, any> {
    canvasNode: React.ReactNode

    constructor(props: any){
        super(props);
        this.state = {
            width: 100,
            height: 100,
            income: this.props.income,
            spent: this.props.spent
        };
        this.expandContainer = this.expandContainer.bind(this)
        this.shrinkContainer = this.shrinkContainer.bind(this)
        this.addCoin = this.addCoin.bind(this)
        this.removeCoins = this.removeCoins.bind(this)
        this.loop = this.loop.bind(this)
        this.stopLoop = this.stopLoop.bind(this)
        this.startLoop = this.startLoop.bind(this)
        this.world = new box2d.b2World(new box2d.b2Vec2(0, 15))
        this.coins = []
        this.container = []
        this.reshapeList = []
        this.reshapeSlopesList = []
        this.destroyList = []
        this.scale = 250
        this.containerRadius = scale(window.innerWidth, 100, 2000, 100, 200)
        this.coinRadius = scale(window.innerWidth, 100, 2000, 10, 20)
        // 160
        // 16
    }

    private updateDimensions() {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight
        }, () => {
            if (!this._frameId) {
                this.createBox2DScene()
                this.startLoop()
            }
        });
    }

    private createBox2DScene() {
        const bd = new box2d.b2BodyDef()
        const fd = new box2d.b2FixtureDef()

        // Borders definition
        fd.friction = 1
        fd.density = 1
        fd.restitution = 0.75

        // Make obstacles
        fd.friction = 0
        fd.density = 0
        fd.restitution = 0
        for (let i = 0; i<25; i++) {
            let angleRad = 80 + (10 - 20 * Math.random()) * Math.PI / 180
            fd.shape = new box2d.b2PolygonShape()
            fd.shape.SetAsBox(
                2 / this.scale,
                this.canvasNode.width / 50 / this.scale)
            bd.position.Set(
                Math.random() * this.canvasNode.width / this.scale,
                Math.random() * this.canvasNode.height / this.scale)
            bd.angle = angleRad
            this.container.push(this.world.CreateBody(bd))
            this.container[this.container.length - 1].CreateFixture(fd)
        }
    }

    private expandContainer() {
        //Increase container size
        this.containerRadius += 5
        this.reshapeList = this.container

        console.log('Number of coins: ' + this.coins.length)
        console.log('Container surface: ' + Math.pow(this.containerRadius, 2) * Math.PI)
        console.log('Coins surface: ' + this.coins.length * Math.pow(this.coinRadius, 2) * Math.PI)
    }

    private shrinkContainer() {
        //Decrease container size
        this.containerRadius = 80
        this.reshapeList = this.container

        console.log('Number of coins: ' + this.coins.length)
        console.log('Container surface: ' + Math.pow(this.containerRadius, 2) * Math.PI)
        console.log('Coins surface: ' + this.coins.length * Math.pow(this.coinRadius, 2) * Math.PI)
    }

    private addCoin() {
        const bd = new box2d.b2BodyDef()
        const fd = new box2d.b2FixtureDef()

        fd.friction = 0
        fd.density = 1
        fd.restitution = 0.1

        bd.type = box2d.b2BodyType.b2_dynamicBody
        bd.position.Set(this.canvasNode.width / 2 / this.scale + ((this.containerRadius / this.scale / 100 / 2) - (this.containerRadius / this.scale / 100) * Math.random()), 0)
        fd.shape = new box2d.b2CircleShape(this.coinRadius / this.scale)
    
        this.coins.push(this.world.CreateBody(bd))
        this.coins[this.coins.length - 1].CreateFixture(fd)
    }

    private removeCoins() {
        // Get the right coin to delete
        this.destroyList.push(this.coins[0])
        this.coins.shift()
    }

    public componentDidUpdate() {
        console.log(this.props.paused)
    }

    public componentDidMount() {
        this.updateDimensions()
        // this.world.paused = true
        // console.log(this.world)
        window.addEventListener("resize", this.updateDimensions.bind(this))
    }

    public componentWillUnmount() {
        this.stopLoop()
    }

    private startLoop() {
        if( !this._frameId ) {
            console.log('frameId doesnt exist')
          this._frameId = window.requestAnimationFrame( this.loop )
        }
      }
      
    private loop() {
        const ctx = this.canvasNode.getContext("2d")

        // Update Box2d world
        this.world.Step(1 / 70, 10, 10)

        // Erase the canvas
        //ctx.fillStyle = "#ffffff"
        //ctx.fillRect(0, 0, this.canvasNode.width, this.canvasNode.height)
        ctx.clearRect(0, 0, this.canvasNode.width, this.canvasNode.height)

        for (var b = this.world.GetBodyList(); b; b = b.m_next) {
            // Draw the borders
            if (b.GetType() == 0) {
                /* const v = b.GetFixtureList().GetShape().m_vertices
                ctx.fillStyle = '#d1d2d3';
                ctx.save()
                ctx.translate(
                    b.GetPosition().x * this.scale,
                    b.GetPosition().y * this.scale)
                ctx.rotate(b.GetAngle())
                ctx.beginPath()
                ctx.moveTo(v[0].x * this.scale, v[0].y * this.scale)
                ctx.lineTo(v[1].x * this.scale, v[1].y * this.scale)
                ctx.lineTo(v[2].x * this.scale, v[2].y * this.scale)
                ctx.lineTo(v[3].x * this.scale, v[3].y * this.scale)
                ctx.closePath()
                ctx.fill()
                ctx.restore() */
            // Draw the coins
            } else {
                ctx.fillStyle = "#ad427f"
                ctx.beginPath()
                ctx.arc(
                    b.GetPosition().x * this.scale, 
                    b.GetPosition().y * this.scale - window.pageYOffset * 0.65,
                    this.coinRadius - 4, 0, 2 * Math.PI)
                ctx.fill()
            }
        }

        // Coins registered to be deleted
        for (let i in this.destroyList) {
            this.world.DestroyBody(this.destroyList[i])
        }
        this.destroyList = []

        // Container borders registered to be updated
        if (this.reshapeList.length > 0) {
            for (let i in this.reshapeList) {
                // Create a new fixture
                const fd = new box2d.b2FixtureDef()
                fd.friction = 0
                fd.density = 0
                fd.restitution = 0.1
                fd.shape = new box2d.b2PolygonShape()
                fd.shape.SetAsBox(
                    2 / this.scale,
                    this.containerRadius / this.scale / 3)
                // Get the brick and destroy the fixture associated to it
                let brick = this.reshapeList[i]
                brick.DestroyFixture(brick.GetFixtureList());
                // Set the new brick body position and fixture
                let angleDeg = 360 / 8 * (i - 1) * Math.PI / 180
                brick.CreateFixture(fd)
                brick.SetPosition({
                    x: Math.cos(angleDeg) * (this.containerRadius / this.scale) + (this.canvasNode.width / 2 / this.scale),
                    y: Math.sin(angleDeg) * (this.containerRadius / this.scale) + (this.canvasNode.height / 2 / this.scale)
                })
            }
            this.reshapeList = []
            // console.log(this.container[0].GetFixtureList())
        }

        // Slope borders registered to be updated
        if (this.reshapeSlopesList.length > 0) {
            this.reshapeSlopesList = []
        }
        // Fill the container with coins while the surface of all the coins is less than
        // the surface of the container. Had to multiply the surface of the coins by a 
        // value to take into account the parts not covered by the coins
        if (Math.pow(this.containerRadius, 2) * Math.PI > 
            (Math.pow(this.coinRadius, 2) * Math.PI * this.coins.length * 1.25)) {
            this.addCoin()
        }

        // Create the ghost circles
        /*ctx.strokeStyle = "#a51285"
        ctx.lineWidth = 3
        ctx.beginPath()
        ctx.arc(
            this.canvasNode.width * 0.5, 
            this.canvasNode.height * 0.5,
            this.containerRadius, 0, 2 * Math.PI)
        ctx.stroke()*/

        this._frameId = window.requestAnimationFrame( this.loop )
    }
    
    private stopLoop() {
        window.cancelAnimationFrame( this._frameId )
        this._frameId = null
    }

    public render() {
        return (
            <React.Fragment>
                <canvas
                    className='fixedCanvas'
                    onClick={this.expandContainer}
                    ref={el => {this.canvasNode = el}}
                    width={this.state.width}
                    height={this.state.height}
                    style={{zIndex: this.props.zIndex}}
                />
            </React.Fragment>
        );
    }
}